import { axiosV1 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type SendTestEmailProps = {
  emailData: any;
};

export const sendTestEmail = async ({ emailData }: SendTestEmailProps) => {
  const body = { emailData };

  const { data } = await axiosV1.post('/comms/test-email', body);

  const decodedData = await decryptResponse(data);

  return decodedData;
};
